<template>
  <div class="row text-start mx-0">
    <button class="mes-button mx-0 mb-4" @click="detail = false">返回</button>
  </div>
  <div class="text-start" style="font-size: 18px">
    <span>機台：{{ maintainData.device }}</span>
  </div>
  <div class="text-start" style="font-size: 18px">
    <span>維修別：{{ maintainData.category }}</span>
  </div>
  <div class="text-start" style="font-size: 18px">
    <span>故障/異常描述：{{ maintainData.description }}</span>
  </div>
  <div class="text-start" style="font-size: 18px">
    <span
      >維修人員：<span
        class="py-1 px-2"
        style="background: #c8c9ca; min-width: max-content"
        >{{ maintainData.personnel }}</span
      ></span
    >
  </div>
  <div class="text-start" style="font-size: 18px">
    <span>維修時間：{{ maintainData.time }}</span>
  </div>
  <div class="text-start mb-3" style="font-size: 18px">
    <span>維修說明：</span>
    <div class="form-floating">
      <textarea
        class="form-control p-2"
        placeholder="Leave a comment here"
        id="floatingTextarea"
        style="height: 200px; white-space: pre-line"
        v-model="maintainData.repairReason"
        disabled
      ></textarea>
    </div>
  </div>
  <div class="text-start" style="font-size: 18px">
    <template v-if="maintainData.appendix.length > 0">
      <div
        v-for="(item, key) in maintainData.appendix"
        :key="key"
        class="d-flex align-content-center flex-wrap mb-2 mes-appendix"
      >
        <span><template v-if="key == 0">附件：</template></span>
        <div
          style="
            cursor: pointer;
            width: 200px;
            border: 1px solid rgba(118, 118, 118, 0.3);
            background: #e9ecef;
            padding: 2px;
          "
          @click="previewInformation(item.src)"
        >
          {{ item.name }}
        </div>
        <!-- <input
          type="text"
          :value="item.name"
          disabled
          style="cursor: pointer"
          @click="previewInformation(item.src)"
        /> -->
        <a :href="item.src" :download="item.name">下載</a>
      </div>
    </template>
    <template v-else><span>附件：無</span></template>
  </div>
  <commonModal :modalShow="modalShow" :size="'xl'">
    <template v-slot:modalheader>
      <button type="button" class="close" @click="modalShow = false">×</button>
    </template>
    <template v-slot:default>
      <img
        v-if="modalShowSrc"
        :src="modalShowSrc"
        style="width: 100%"
        alt="Preview"
      />
      <template v-else>無法預覽</template>
    </template>
  </commonModal>
</template>

<script>
import { inject, ref, watch } from "vue";
import commonModal from "@/components/commonModal.vue";
export default {
  components: { commonModal },
  setup() {
    const detail = inject("detail");
    const maintainData = inject("maintainData");

    const modalShow = ref(false);
    const modalShowSrc = ref("");

    const previewInformation = (src) => {
      let fileType = "";
      const extension = src.split(".").pop().toLowerCase();

      if (
        extension === "jpg" ||
        extension === "jpeg" ||
        extension === "png" ||
        extension === "gif"
      ) {
        fileType = "image";
      } else if (extension === "pdf") {
        fileType = "pdf";
      }
      if (fileType === "image") {
        window.open(src, "_blank"); // open in a new tab
        // modalShowSrc.value = src;
        // modalShow.value = true;
      } else if (fileType === "pdf") {
        window.open(src, "_blank"); // For PDF files, open in a new tab
      } else {
        modalShowSrc.value = "";
        modalShow.value = true;
      }
    };

    watch(modalShow, (newValue) => {
      if (newValue == false) {
        modalShowSrc.value = "";
      }
    });

    return {
      detail,
      maintainData,
      modalShow,
      modalShowSrc,
      previewInformation,
    };
  },
};
</script>

<style scoped>
.mes-button,
a {
  border: 0px;
  border-radius: 5px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  padding: 0 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 1.5rem;
  cursor: pointer;
  text-decoration: none;
}
.mes-appendix span {
  width: 55px;
  line-height: 33px;
}
</style>
